import { render, staticRenderFns } from "./personVipDialog.vue?vue&type=template&id=665710de&scoped=true"
import script from "./personVipDialog.vue?vue&type=script&lang=js"
export * from "./personVipDialog.vue?vue&type=script&lang=js"
import style0 from "./personVipDialog.vue?vue&type=style&index=0&id=665710de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665710de",
  null
  
)

export default component.exports